/* Automatisch erzeugt (.tmp/gen-theme-tokens.mjs, 15.10.2026): Design-Tokens je Theme, wie Antd sie bis Stufe 8 berechnete. */
/* Nicht von Hand ändern; Werte eines Themes ändern sich über `themeCatalog.ts` und einen neuen Lauf (vor der Antd-Entfernung). Ausnahme: `web-*` (15.10.2026, nach der Antd-Entfernung) ist aus `kraftraum-*` mit den Website-Werten abgeleitet, `pflaume-*` (31.10.2026) aus `impuls-*` mit den Pflaume-Werten. */
export const themeTokenKeys = ["blue4","borderRadius","borderRadiusLG","borderRadiusSM","borderRadiusXS","boxShadow","boxShadowSecondary","boxShadowTertiary","colorBgBase","colorBgContainer","colorBgElevated","colorBgLayout","colorBgMask","colorBgSpotlight","colorBgTextHover","colorBorder","colorBorderSecondary","colorError","colorErrorActive","colorErrorBg","colorErrorBorder","colorErrorHover","colorErrorText","colorFill","colorFillAlter","colorFillQuaternary","colorFillSecondary","colorFillTertiary","colorHighlight","colorIcon","colorIconHover","colorInfo","colorInfoBg","colorInfoBorder","colorInfoText","colorLink","colorLinkHover","colorPrimary","colorPrimaryActive","colorPrimaryBg","colorPrimaryBgHover","colorPrimaryBorder","colorPrimaryHover","colorPrimaryText","colorPrimaryTextHover","colorSplit","colorSuccess","colorSuccessBg","colorSuccessBorder","colorSuccessText","colorText","colorTextBase","colorTextDescription","colorTextDisabled","colorTextHeading","colorTextLabel","colorTextLightSolid","colorTextPlaceholder","colorTextQuaternary","colorTextSecondary","colorTextTertiary","colorWarning","colorWarningBg","colorWarningBorder","colorWarningText","colorWhite","controlHeight","controlHeightLG","controlHeightSM","controlItemBgActive","controlItemBgHover","fontFamily","fontFamilyCode","fontSize","fontSizeHeading1","fontSizeHeading2","fontSizeHeading3","fontSizeHeading4","fontSizeHeading5","fontSizeIcon","fontSizeLG","fontSizeSM","fontSizeXL","fontWeightStrong","lineHeight","lineHeightLG","lineHeightSM","lineType","lineWidth","lineWidthBold","margin","marginLG","marginMD","marginSM","marginXL","marginXS","marginXXS","motionDurationFast","motionDurationMid","motionDurationSlow","padding","paddingLG","paddingMD","paddingSM","paddingXL","paddingXS","paddingXXS","zIndexBase","zIndexPopupBase","blue","purple","cyan","green","magenta","pink","red","orange","yellow","volcano","geekblue","gold","lime"] as const;
type NumericTokenKey = `borderRadius${string}` | `controlHeight${string}` | "controlHeight" | `fontSize${string}` | "fontSize" | "fontWeightStrong" | `lineHeight${string}` | "lineHeight" | `lineWidth${string}` | "lineWidth" | `margin${string}` | "margin" | `padding${string}` | "padding" | `zIndex${string}`;
export type ThemeToken = { [K in (typeof themeTokenKeys)[number]]: K extends NumericTokenKey ? number : string };
export const frozenThemeTokens: Record<string, ThemeToken> = {
 "noir-light": {
  "blue4": "#69b1ff",
  "borderRadius": 6,
  "borderRadiusLG": 10,
  "borderRadiusSM": 4,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#fafaf8",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "rgba(10, 10, 10, 0.11)",
  "colorBorderSecondary": "rgba(10, 10, 10, 0.11)",
  "colorError": "#d6334a",
  "colorErrorActive": "#b02139",
  "colorErrorBg": "#fff0f0",
  "colorErrorBorder": "#fcb6b8",
  "colorErrorHover": "#e35b68",
  "colorErrorText": "#d6334a",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(10, 10, 10, 0.04)",
  "colorHighlight": "#d6334a",
  "colorIcon": "#9a9a95",
  "colorIconHover": "#0a0a0a",
  "colorInfo": "#0a0a0a",
  "colorInfoBg": "#4a4a4a",
  "colorInfoBorder": "#303030",
  "colorInfoText": "#0a0a0a",
  "colorLink": "#8a6d33",
  "colorLinkHover": "#8a6d33",
  "colorPrimary": "#0a0a0a",
  "colorPrimaryActive": "#000000",
  "colorPrimaryBg": "#4a4a4a",
  "colorPrimaryBgHover": "#3d3d3d",
  "colorPrimaryBorder": "#303030",
  "colorPrimaryHover": "#171717",
  "colorPrimaryText": "#0a0a0a",
  "colorPrimaryTextHover": "#171717",
  "colorSplit": "rgba(10, 10, 10, 0.11)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "#0a0a0a",
  "colorTextBase": "#000",
  "colorTextDescription": "#9a9a95",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "#0a0a0a",
  "colorTextLabel": "#5f5f5b",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "#9a9a95",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "#5f5f5b",
  "colorTextTertiary": "#9a9a95",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 38,
  "controlHeightLG": 47.5,
  "controlHeightSM": 28.5,
  "controlItemBgActive": "rgba(184, 147, 74, 0.12)",
  "controlItemBgHover": "rgba(10, 10, 10, 0.04)",
  "fontFamily": "\"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "noir-dark": {
  "blue4": "#15417e",
  "borderRadius": 6,
  "borderRadiusLG": 10,
  "borderRadiusSM": 4,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#0f0f0f",
  "colorBgElevated": "#121212",
  "colorBgLayout": "#070707",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "rgba(255, 255, 255, 0.10)",
  "colorBorderSecondary": "rgba(255, 255, 255, 0.10)",
  "colorError": "#dc5061",
  "colorErrorActive": "#ad424f",
  "colorErrorBg": "#2c181b",
  "colorErrorBorder": "#5b292f",
  "colorErrorHover": "#e87780",
  "colorErrorText": "#dc5061",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255, 255, 255, 0.05)",
  "colorHighlight": "#dc5061",
  "colorIcon": "rgba(245, 245, 242, 0.40)",
  "colorIconHover": "rgba(245, 245, 242, 0.94)",
  "colorInfo": "#d3d3d1",
  "colorInfoBg": "#2a2a28",
  "colorInfoBorder": "#585857",
  "colorInfoText": "#d3d3d1",
  "colorLink": "#bba474",
  "colorLinkHover": "#d9bd85",
  "colorPrimary": "#d3d3d1",
  "colorPrimaryActive": "#a6a6a4",
  "colorPrimaryBg": "#585857",
  "colorPrimaryBgHover": "#797978",
  "colorPrimaryBorder": "#585857",
  "colorPrimaryHover": "#e8e7da",
  "colorPrimaryText": "#d3d3d1",
  "colorPrimaryTextHover": "#e8e7da",
  "colorSplit": "rgba(255, 255, 255, 0.10)",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "rgba(245, 245, 242, 0.94)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(245, 245, 242, 0.40)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "rgba(245, 245, 242, 0.94)",
  "colorTextLabel": "rgba(245, 245, 242, 0.62)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(245, 245, 242, 0.40)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "rgba(245, 245, 242, 0.62)",
  "colorTextTertiary": "rgba(245, 245, 242, 0.40)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 38,
  "controlHeightLG": 47.5,
  "controlHeightSM": 28.5,
  "controlItemBgActive": "rgba(200, 169, 106, 0.2)",
  "controlItemBgHover": "rgba(255, 255, 255, 0.05)",
  "fontFamily": "\"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "kraftraum-light": {
  "blue4": "#69b1ff",
  "borderRadius": 6,
  "borderRadiusLG": 8,
  "borderRadiusSM": 4,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f2f2ee",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "rgba(17, 18, 20, 0.10)",
  "colorBorderSecondary": "rgba(17, 18, 20, 0.10)",
  "colorError": "#ff3b47",
  "colorErrorActive": "#d92739",
  "colorErrorBg": "#fff1f0",
  "colorErrorBorder": "#ffb8b5",
  "colorErrorHover": "#ff6369",
  "colorErrorText": "#ff3b47",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(17, 18, 20, 0.05)",
  "colorHighlight": "#ff3b47",
  "colorIcon": "#8a8c91",
  "colorIconHover": "#111214",
  "colorInfo": "#111214",
  "colorInfoBg": "#4f5254",
  "colorInfoBorder": "#37393b",
  "colorInfoText": "#111214",
  "colorLink": "#7a5a00",
  "colorLinkHover": "#7a5a00",
  "colorPrimary": "#111214",
  "colorPrimaryActive": "#000000",
  "colorPrimaryBg": "#4f5254",
  "colorPrimaryBgHover": "#434547",
  "colorPrimaryBorder": "#37393b",
  "colorPrimaryHover": "#1f2021",
  "colorPrimaryText": "#111214",
  "colorPrimaryTextHover": "#1f2021",
  "colorSplit": "rgba(17, 18, 20, 0.10)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "#111214",
  "colorTextBase": "#000",
  "colorTextDescription": "#8a8c91",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "#111214",
  "colorTextLabel": "#53555a",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "#8a8c91",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "#53555a",
  "colorTextTertiary": "#8a8c91",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 38,
  "controlHeightLG": 47.5,
  "controlHeightSM": 28.5,
  "controlItemBgActive": "rgba(17, 18, 20, 0.12)",
  "controlItemBgHover": "rgba(17, 18, 20, 0.05)",
  "fontFamily": "\"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "kraftraum-dark": {
  "blue4": "#15417e",
  "borderRadius": 6,
  "borderRadiusLG": 8,
  "borderRadiusSM": 4,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#151618",
  "colorBgElevated": "#1e2023",
  "colorBgLayout": "#0b0c0d",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "rgba(255, 255, 255, 0.08)",
  "colorBorderSecondary": "rgba(255, 255, 255, 0.08)",
  "colorError": "#dc353f",
  "colorErrorActive": "#ad2d35",
  "colorErrorBg": "#2c1418",
  "colorErrorBorder": "#5b2023",
  "colorErrorHover": "#e85b61",
  "colorErrorText": "#dc353f",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255, 255, 255, 0.05)",
  "colorHighlight": "#dc353f",
  "colorIcon": "rgba(255, 255, 255, 0.42)",
  "colorIconHover": "rgba(255, 255, 255, 0.93)",
  "colorInfo": "#dcb90c",
  "colorInfoBg": "#2c2611",
  "colorInfoBorder": "#5b4e11",
  "colorInfoText": "#dcb90c",
  "colorLink": "#dcb90c",
  "colorLinkHover": "#ffd60a",
  "colorPrimary": "#dcb90c",
  "colorPrimaryActive": "#ad920e",
  "colorPrimaryBg": "#5b4e11",
  "colorPrimaryBgHover": "#7e6b10",
  "colorPrimaryBorder": "#5b4e11",
  "colorPrimaryHover": "#e8cf30",
  "colorPrimaryText": "#dcb90c",
  "colorPrimaryTextHover": "#e8cf30",
  "colorSplit": "rgba(255, 255, 255, 0.08)",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "rgba(255, 255, 255, 0.93)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(255, 255, 255, 0.42)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "rgba(255, 255, 255, 0.93)",
  "colorTextLabel": "rgba(255, 255, 255, 0.64)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(255, 255, 255, 0.42)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "rgba(255, 255, 255, 0.64)",
  "colorTextTertiary": "rgba(255, 255, 255, 0.42)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 38,
  "controlHeightLG": 47.5,
  "controlHeightSM": 28.5,
  "controlItemBgActive": "rgba(255, 214, 10, 0.2)",
  "controlItemBgHover": "rgba(255, 255, 255, 0.05)",
  "fontFamily": "\"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "classic-light": {
  "blue4": "#69b1ff",
  "borderRadius": 6,
  "borderRadiusLG": 8,
  "borderRadiusSM": 4,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f5f5f5",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "#d9d9d9",
  "colorBorderSecondary": "rgba(0, 0, 0, 0.10)",
  "colorError": "#ff4d4f",
  "colorErrorActive": "#d9363e",
  "colorErrorBg": "#fff2f0",
  "colorErrorBorder": "#ffccc7",
  "colorErrorHover": "#ff7875",
  "colorErrorText": "#ff4d4f",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(0,0,0,0.04)",
  "colorHighlight": "#ff4d4f",
  "colorIcon": "rgba(0,0,0,0.45)",
  "colorIconHover": "rgba(0, 0, 0, 0.88)",
  "colorInfo": "#1677ff",
  "colorInfoBg": "#e6f4ff",
  "colorInfoBorder": "#91caff",
  "colorInfoText": "#1677ff",
  "colorLink": "#1677ff",
  "colorLinkHover": "#1677ff",
  "colorPrimary": "#1677ff",
  "colorPrimaryActive": "#0958d9",
  "colorPrimaryBg": "#e6f4ff",
  "colorPrimaryBgHover": "#bae0ff",
  "colorPrimaryBorder": "#91caff",
  "colorPrimaryHover": "#4096ff",
  "colorPrimaryText": "#1677ff",
  "colorPrimaryTextHover": "#4096ff",
  "colorSplit": "rgba(0, 0, 0, 0.10)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "rgba(0, 0, 0, 0.88)",
  "colorTextBase": "#000",
  "colorTextDescription": "rgba(0,0,0,0.45)",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "rgba(0, 0, 0, 0.88)",
  "colorTextLabel": "rgba(0, 0, 0, 0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(0,0,0,0.25)",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "rgba(0, 0, 0, 0.65)",
  "colorTextTertiary": "rgba(0,0,0,0.45)",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#e6f4ff",
  "controlItemBgHover": "rgba(0,0,0,0.04)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "classic-dark": {
  "blue4": "#15417e",
  "borderRadius": 6,
  "borderRadiusLG": 8,
  "borderRadiusSM": 4,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#141414",
  "colorBgElevated": "#1f1f1f",
  "colorBgLayout": "#000000",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "#424242",
  "colorBorderSecondary": "rgba(255, 255, 255, 0.12)",
  "colorError": "#dc4446",
  "colorErrorActive": "#ad393a",
  "colorErrorBg": "#2c1618",
  "colorErrorBorder": "#5b2526",
  "colorErrorHover": "#e86e6b",
  "colorErrorText": "#dc4446",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255,255,255,0.08)",
  "colorHighlight": "#dc4446",
  "colorIcon": "rgba(255,255,255,0.45)",
  "colorIconHover": "rgba(255, 255, 255, 0.85)",
  "colorInfo": "#1668dc",
  "colorInfoBg": "#111a2c",
  "colorInfoBorder": "#15325b",
  "colorInfoText": "#1668dc",
  "colorLink": "#3983dc",
  "colorLinkHover": "#4096ff",
  "colorPrimary": "#1668dc",
  "colorPrimaryActive": "#1554ad",
  "colorPrimaryBg": "#15325b",
  "colorPrimaryBgHover": "#15417e",
  "colorPrimaryBorder": "#15325b",
  "colorPrimaryHover": "#3c89e8",
  "colorPrimaryText": "#1668dc",
  "colorPrimaryTextHover": "#3c89e8",
  "colorSplit": "rgba(255, 255, 255, 0.12)",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "rgba(255, 255, 255, 0.85)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(255,255,255,0.45)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "rgba(255, 255, 255, 0.85)",
  "colorTextLabel": "rgba(255, 255, 255, 0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(255,255,255,0.25)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "rgba(255, 255, 255, 0.65)",
  "colorTextTertiary": "rgba(255,255,255,0.45)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#15325b",
  "controlItemBgHover": "rgba(255,255,255,0.08)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "slate-light": {
  "blue4": "#69b1ff",
  "borderRadius": 6,
  "borderRadiusLG": 10,
  "borderRadiusSM": 4,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f3f5f8",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "rgba(15, 23, 42, 0.10)",
  "colorBorderSecondary": "rgba(15, 23, 42, 0.10)",
  "colorError": "#e11d48",
  "colorErrorActive": "#ba0f3a",
  "colorErrorBg": "#ffedee",
  "colorErrorBorder": "#ff9ca7",
  "colorErrorHover": "#ed4564",
  "colorErrorText": "#e11d48",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(15, 23, 42, 0.04)",
  "colorHighlight": "#e11d48",
  "colorIcon": "#94a3b8",
  "colorIconHover": "#0f172a",
  "colorInfo": "#0e7490",
  "colorInfoBg": "#bacecf",
  "colorInfoBorder": "#69acb5",
  "colorInfoText": "#0e7490",
  "colorLink": "#0e7490",
  "colorLinkHover": "#0e7490",
  "colorPrimary": "#0e7490",
  "colorPrimaryActive": "#055069",
  "colorPrimaryBg": "#bacecf",
  "colorPrimaryBgHover": "#8fbec2",
  "colorPrimaryBorder": "#69acb5",
  "colorPrimaryHover": "#28869c",
  "colorPrimaryText": "#0e7490",
  "colorPrimaryTextHover": "#28869c",
  "colorSplit": "rgba(15, 23, 42, 0.10)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "#0f172a",
  "colorTextBase": "#000",
  "colorTextDescription": "#94a3b8",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "#0f172a",
  "colorTextLabel": "#475569",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "#94a3b8",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "#475569",
  "colorTextTertiary": "#94a3b8",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 36,
  "controlHeightLG": 45,
  "controlHeightSM": 27,
  "controlItemBgActive": "rgba(14, 116, 144, 0.12)",
  "controlItemBgHover": "rgba(15, 23, 42, 0.04)",
  "fontFamily": "\"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "slate-dark": {
  "blue4": "#15417e",
  "borderRadius": 6,
  "borderRadiusLG": 10,
  "borderRadiusSM": 4,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#111827",
  "colorBgElevated": "#182336",
  "colorBgLayout": "#0b1120",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "rgba(255, 255, 255, 0.09)",
  "colorBorderSecondary": "rgba(255, 255, 255, 0.09)",
  "colorError": "#d86374",
  "colorErrorActive": "#aa505d",
  "colorErrorBg": "#2b1a1e",
  "colorErrorBorder": "#593036",
  "colorErrorHover": "#e88e98",
  "colorErrorText": "#d86374",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255, 255, 255, 0.05)",
  "colorHighlight": "#d86374",
  "colorIcon": "rgba(148, 163, 184, 0.62)",
  "colorIconHover": "rgba(241, 245, 249, 0.94)",
  "colorInfo": "#20b6cd",
  "colorInfoBg": "#122529",
  "colorInfoBorder": "#184d55",
  "colorInfoText": "#20b6cd",
  "colorLink": "#5bc8d7",
  "colorLinkHover": "#67e8f9",
  "colorPrimary": "#20b6cd",
  "colorPrimaryActive": "#1d90a2",
  "colorPrimaryBg": "#184d55",
  "colorPrimaryBgHover": "#1a6a76",
  "colorPrimaryBorder": "#184d55",
  "colorPrimaryHover": "#46d3e3",
  "colorPrimaryText": "#20b6cd",
  "colorPrimaryTextHover": "#46d3e3",
  "colorSplit": "rgba(255, 255, 255, 0.09)",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "rgba(241, 245, 249, 0.94)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(148, 163, 184, 0.62)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "rgba(241, 245, 249, 0.94)",
  "colorTextLabel": "rgba(203, 213, 225, 0.70)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(148, 163, 184, 0.62)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "rgba(203, 213, 225, 0.70)",
  "colorTextTertiary": "rgba(148, 163, 184, 0.62)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 36,
  "controlHeightLG": 45,
  "controlHeightSM": 27,
  "controlItemBgActive": "rgba(34, 211, 238, 0.2)",
  "controlItemBgHover": "rgba(255, 255, 255, 0.05)",
  "fontFamily": "\"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "kontor-light": {
  "blue4": "#69b1ff",
  "borderRadius": 4,
  "borderRadiusLG": 8,
  "borderRadiusSM": 2,
  "borderRadiusXS": 1,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#fffefb",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f5f3ee",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "rgba(27, 34, 48, 0.11)",
  "colorBorderSecondary": "rgba(27, 34, 48, 0.11)",
  "colorError": "#c2410c",
  "colorErrorActive": "#9c2802",
  "colorErrorBg": "#fff1e6",
  "colorErrorBorder": "#e8a67d",
  "colorErrorHover": "#cf602d",
  "colorErrorText": "#c2410c",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(27, 34, 48, 0.045)",
  "colorHighlight": "#c2410c",
  "colorIcon": "#8b919c",
  "colorIconHover": "#1b2230",
  "colorInfo": "#1f5f4a",
  "colorInfoBg": "#959e99",
  "colorInfoBorder": "#6b857a",
  "colorInfoText": "#1f5f4a",
  "colorLink": "#1f5f4a",
  "colorLinkHover": "#8a6424",
  "colorPrimary": "#1f5f4a",
  "colorPrimaryActive": "#10382c",
  "colorPrimaryBg": "#959e99",
  "colorPrimaryBgHover": "#89918d",
  "colorPrimaryBorder": "#6b857a",
  "colorPrimaryHover": "#346b57",
  "colorPrimaryText": "#1f5f4a",
  "colorPrimaryTextHover": "#346b57",
  "colorSplit": "rgba(27, 34, 48, 0.11)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "#1b2230",
  "colorTextBase": "#000",
  "colorTextDescription": "#8b919c",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "#1b2230",
  "colorTextLabel": "#535b69",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "#8b919c",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "#535b69",
  "colorTextTertiary": "#8b919c",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 36,
  "controlHeightLG": 45,
  "controlHeightSM": 27,
  "controlItemBgActive": "rgba(31, 95, 74, 0.12)",
  "controlItemBgHover": "rgba(27, 34, 48, 0.045)",
  "fontFamily": "\"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "kontor-dark": {
  "blue4": "#15417e",
  "borderRadius": 4,
  "borderRadiusLG": 8,
  "borderRadiusSM": 2,
  "borderRadiusXS": 1,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#171b22",
  "colorBgElevated": "#1f242d",
  "colorBgLayout": "#101318",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "rgba(255, 255, 255, 0.08)",
  "colorBorderSecondary": "rgba(255, 255, 255, 0.08)",
  "colorError": "#d76516",
  "colorErrorActive": "#a95215",
  "colorErrorBg": "#2b1a11",
  "colorErrorBorder": "#593115",
  "colorErrorHover": "#e8893c",
  "colorErrorText": "#d76516",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255, 255, 255, 0.05)",
  "colorHighlight": "#d76516",
  "colorIcon": "rgba(245, 242, 235, 0.42)",
  "colorIconHover": "rgba(245, 242, 235, 0.92)",
  "colorInfo": "#469778",
  "colorInfoBg": "#16201d",
  "colorInfoBorder": "#264237",
  "colorInfoText": "#469778",
  "colorLink": "#5fa98b",
  "colorLinkHover": "#e2bd73",
  "colorPrimary": "#469778",
  "colorPrimaryActive": "#3a7861",
  "colorPrimaryBg": "#264237",
  "colorPrimaryBgHover": "#2f5949",
  "colorPrimaryBorder": "#264237",
  "colorPrimaryHover": "#69a98e",
  "colorPrimaryText": "#469778",
  "colorPrimaryTextHover": "#69a98e",
  "colorSplit": "rgba(255, 255, 255, 0.08)",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "rgba(245, 242, 235, 0.92)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(245, 242, 235, 0.42)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "rgba(245, 242, 235, 0.92)",
  "colorTextLabel": "rgba(245, 242, 235, 0.64)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(245, 242, 235, 0.42)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "rgba(245, 242, 235, 0.64)",
  "colorTextTertiary": "rgba(245, 242, 235, 0.42)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 36,
  "controlHeightLG": 45,
  "controlHeightSM": 27,
  "controlItemBgActive": "rgba(79, 174, 138, 0.2)",
  "controlItemBgHover": "rgba(255, 255, 255, 0.05)",
  "fontFamily": "\"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "violet-light": {
  "blue4": "#69b1ff",
  "borderRadius": 8,
  "borderRadiusLG": 10,
  "borderRadiusSM": 6,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f5f5f5",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "#d9d9d9",
  "colorBorderSecondary": "#f0f0f0",
  "colorError": "#ff4d4f",
  "colorErrorActive": "#d9363e",
  "colorErrorBg": "#fff2f0",
  "colorErrorBorder": "#ffccc7",
  "colorErrorHover": "#ff7875",
  "colorErrorText": "#ff4d4f",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(0,0,0,0.04)",
  "colorHighlight": "#ff4d4f",
  "colorIcon": "rgba(0,0,0,0.45)",
  "colorIconHover": "rgba(0,0,0,0.88)",
  "colorInfo": "#1677ff",
  "colorInfoBg": "#e6f4ff",
  "colorInfoBorder": "#91caff",
  "colorInfoText": "#1677ff",
  "colorLink": "#1677ff",
  "colorLinkHover": "#69b1ff",
  "colorPrimary": "#722ed1",
  "colorPrimaryActive": "#531dab",
  "colorPrimaryBg": "#f9f0ff",
  "colorPrimaryBgHover": "#efdbff",
  "colorPrimaryBorder": "#d3adf7",
  "colorPrimaryHover": "#9254de",
  "colorPrimaryText": "#722ed1",
  "colorPrimaryTextHover": "#9254de",
  "colorSplit": "rgba(5,5,5,0.06)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "rgba(0,0,0,0.88)",
  "colorTextBase": "#000",
  "colorTextDescription": "rgba(0,0,0,0.45)",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "rgba(0,0,0,0.88)",
  "colorTextLabel": "rgba(0,0,0,0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(0,0,0,0.25)",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "rgba(0,0,0,0.65)",
  "colorTextTertiary": "rgba(0,0,0,0.45)",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#f9f0ff",
  "controlItemBgHover": "rgba(0,0,0,0.04)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "violet-dark": {
  "blue4": "#15417e",
  "borderRadius": 8,
  "borderRadiusLG": 10,
  "borderRadiusSM": 6,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#141414",
  "colorBgElevated": "#1f1f1f",
  "colorBgLayout": "#000000",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "#424242",
  "colorBorderSecondary": "#303030",
  "colorError": "#dc4446",
  "colorErrorActive": "#ad393a",
  "colorErrorBg": "#2c1618",
  "colorErrorBorder": "#5b2526",
  "colorErrorHover": "#e86e6b",
  "colorErrorText": "#dc4446",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255,255,255,0.08)",
  "colorHighlight": "#dc4446",
  "colorIcon": "rgba(255,255,255,0.45)",
  "colorIconHover": "rgba(255,255,255,0.85)",
  "colorInfo": "#1668dc",
  "colorInfoBg": "#111a2c",
  "colorInfoBorder": "#15325b",
  "colorInfoText": "#1668dc",
  "colorLink": "#1668dc",
  "colorLinkHover": "#15417e",
  "colorPrimary": "#642ab5",
  "colorPrimaryActive": "#51258f",
  "colorPrimaryBg": "#301c4d",
  "colorPrimaryBgHover": "#3e2069",
  "colorPrimaryBorder": "#301c4d",
  "colorPrimaryHover": "#854eca",
  "colorPrimaryText": "#642ab5",
  "colorPrimaryTextHover": "#854eca",
  "colorSplit": "rgba(253,253,253,0.12)",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "rgba(255,255,255,0.85)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(255,255,255,0.45)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "rgba(255,255,255,0.85)",
  "colorTextLabel": "rgba(255,255,255,0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(255,255,255,0.25)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "rgba(255,255,255,0.65)",
  "colorTextTertiary": "rgba(255,255,255,0.45)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#301c4d",
  "controlItemBgHover": "rgba(255,255,255,0.08)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "teal-light": {
  "blue4": "#69b1ff",
  "borderRadius": 8,
  "borderRadiusLG": 10,
  "borderRadiusSM": 6,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f5f5f5",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "#d9d9d9",
  "colorBorderSecondary": "#f0f0f0",
  "colorError": "#ff4d4f",
  "colorErrorActive": "#d9363e",
  "colorErrorBg": "#fff2f0",
  "colorErrorBorder": "#ffccc7",
  "colorErrorHover": "#ff7875",
  "colorErrorText": "#ff4d4f",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(0,0,0,0.04)",
  "colorHighlight": "#ff4d4f",
  "colorIcon": "rgba(0,0,0,0.45)",
  "colorIconHover": "rgba(0,0,0,0.88)",
  "colorInfo": "#1677ff",
  "colorInfoBg": "#e6f4ff",
  "colorInfoBorder": "#91caff",
  "colorInfoText": "#1677ff",
  "colorLink": "#1677ff",
  "colorLinkHover": "#69b1ff",
  "colorPrimary": "#13c2c2",
  "colorPrimaryActive": "#08979c",
  "colorPrimaryBg": "#e6fffb",
  "colorPrimaryBgHover": "#b5f5ec",
  "colorPrimaryBorder": "#87e8de",
  "colorPrimaryHover": "#36cfc9",
  "colorPrimaryText": "#13c2c2",
  "colorPrimaryTextHover": "#36cfc9",
  "colorSplit": "rgba(5,5,5,0.06)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "rgba(0,0,0,0.88)",
  "colorTextBase": "#000",
  "colorTextDescription": "rgba(0,0,0,0.45)",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "rgba(0,0,0,0.88)",
  "colorTextLabel": "rgba(0,0,0,0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(0,0,0,0.25)",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "rgba(0,0,0,0.65)",
  "colorTextTertiary": "rgba(0,0,0,0.45)",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#e6fffb",
  "controlItemBgHover": "rgba(0,0,0,0.04)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "teal-dark": {
  "blue4": "#15417e",
  "borderRadius": 8,
  "borderRadiusLG": 10,
  "borderRadiusSM": 6,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#141414",
  "colorBgElevated": "#1f1f1f",
  "colorBgLayout": "#000000",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "#424242",
  "colorBorderSecondary": "#303030",
  "colorError": "#dc4446",
  "colorErrorActive": "#ad393a",
  "colorErrorBg": "#2c1618",
  "colorErrorBorder": "#5b2526",
  "colorErrorHover": "#e86e6b",
  "colorErrorText": "#dc4446",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255,255,255,0.08)",
  "colorHighlight": "#dc4446",
  "colorIcon": "rgba(255,255,255,0.45)",
  "colorIconHover": "rgba(255,255,255,0.85)",
  "colorInfo": "#1668dc",
  "colorInfoBg": "#111a2c",
  "colorInfoBorder": "#15325b",
  "colorInfoText": "#1668dc",
  "colorLink": "#1668dc",
  "colorLinkHover": "#15417e",
  "colorPrimary": "#13a8a8",
  "colorPrimaryActive": "#138585",
  "colorPrimaryBg": "#144848",
  "colorPrimaryBgHover": "#146262",
  "colorPrimaryBorder": "#144848",
  "colorPrimaryHover": "#33bcb7",
  "colorPrimaryText": "#13a8a8",
  "colorPrimaryTextHover": "#33bcb7",
  "colorSplit": "rgba(253,253,253,0.12)",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "rgba(255,255,255,0.85)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(255,255,255,0.45)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "rgba(255,255,255,0.85)",
  "colorTextLabel": "rgba(255,255,255,0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(255,255,255,0.25)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "rgba(255,255,255,0.65)",
  "colorTextTertiary": "rgba(255,255,255,0.45)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#144848",
  "controlItemBgHover": "rgba(255,255,255,0.08)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "green-light": {
  "blue4": "#69b1ff",
  "borderRadius": 8,
  "borderRadiusLG": 10,
  "borderRadiusSM": 6,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f5f5f5",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "#d9d9d9",
  "colorBorderSecondary": "#f0f0f0",
  "colorError": "#ff4d4f",
  "colorErrorActive": "#d9363e",
  "colorErrorBg": "#fff2f0",
  "colorErrorBorder": "#ffccc7",
  "colorErrorHover": "#ff7875",
  "colorErrorText": "#ff4d4f",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(0,0,0,0.04)",
  "colorHighlight": "#ff4d4f",
  "colorIcon": "rgba(0,0,0,0.45)",
  "colorIconHover": "rgba(0,0,0,0.88)",
  "colorInfo": "#1677ff",
  "colorInfoBg": "#e6f4ff",
  "colorInfoBorder": "#91caff",
  "colorInfoText": "#1677ff",
  "colorLink": "#1677ff",
  "colorLinkHover": "#69b1ff",
  "colorPrimary": "#52c41a",
  "colorPrimaryActive": "#389e0d",
  "colorPrimaryBg": "#f6ffed",
  "colorPrimaryBgHover": "#d9f7be",
  "colorPrimaryBorder": "#b7eb8f",
  "colorPrimaryHover": "#73d13d",
  "colorPrimaryText": "#52c41a",
  "colorPrimaryTextHover": "#73d13d",
  "colorSplit": "rgba(5,5,5,0.06)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "rgba(0,0,0,0.88)",
  "colorTextBase": "#000",
  "colorTextDescription": "rgba(0,0,0,0.45)",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "rgba(0,0,0,0.88)",
  "colorTextLabel": "rgba(0,0,0,0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(0,0,0,0.25)",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "rgba(0,0,0,0.65)",
  "colorTextTertiary": "rgba(0,0,0,0.45)",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#f6ffed",
  "controlItemBgHover": "rgba(0,0,0,0.04)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "green-dark": {
  "blue4": "#15417e",
  "borderRadius": 8,
  "borderRadiusLG": 10,
  "borderRadiusSM": 6,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#141414",
  "colorBgElevated": "#1f1f1f",
  "colorBgLayout": "#000000",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "#424242",
  "colorBorderSecondary": "#303030",
  "colorError": "#dc4446",
  "colorErrorActive": "#ad393a",
  "colorErrorBg": "#2c1618",
  "colorErrorBorder": "#5b2526",
  "colorErrorHover": "#e86e6b",
  "colorErrorText": "#dc4446",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255,255,255,0.08)",
  "colorHighlight": "#dc4446",
  "colorIcon": "rgba(255,255,255,0.45)",
  "colorIconHover": "rgba(255,255,255,0.85)",
  "colorInfo": "#1668dc",
  "colorInfoBg": "#111a2c",
  "colorInfoBorder": "#15325b",
  "colorInfoText": "#1668dc",
  "colorLink": "#1668dc",
  "colorLinkHover": "#15417e",
  "colorPrimary": "#49aa19",
  "colorPrimaryActive": "#3c8618",
  "colorPrimaryBg": "#274916",
  "colorPrimaryBgHover": "#306317",
  "colorPrimaryBorder": "#274916",
  "colorPrimaryHover": "#6abe39",
  "colorPrimaryText": "#49aa19",
  "colorPrimaryTextHover": "#6abe39",
  "colorSplit": "rgba(253,253,253,0.12)",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "rgba(255,255,255,0.85)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(255,255,255,0.45)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "rgba(255,255,255,0.85)",
  "colorTextLabel": "rgba(255,255,255,0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(255,255,255,0.25)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "rgba(255,255,255,0.65)",
  "colorTextTertiary": "rgba(255,255,255,0.45)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#274916",
  "controlItemBgHover": "rgba(255,255,255,0.08)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "vital-light": {
  "blue4": "#69b1ff",
  "borderRadius": 12,
  "borderRadiusLG": 18,
  "borderRadiusSM": 8,
  "borderRadiusXS": 6,
  "boxShadow": "0 2px 4px rgba(10, 59, 55, 0.04), 0 14px 34px -14px rgba(10, 59, 55, 0.24)",
  "boxShadowSecondary": "0 2px 4px rgba(10, 59, 55, 0.04), 0 18px 44px -16px rgba(10, 59, 55, 0.30)",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#eef6f3",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "#edf7f4",
  "colorBorder": "#c7ddd5",
  "colorBorderSecondary": "#dfece7",
  "colorError": "#d64545",
  "colorErrorActive": "#b03034",
  "colorErrorBg": "#fff2f0",
  "colorErrorBorder": "#fccfca",
  "colorErrorHover": "#e3716d",
  "colorErrorText": "#d64545",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "#f5faf8",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "#edf7f4",
  "colorFillTertiary": "#f5faf8",
  "colorHighlight": "#d64545",
  "colorIcon": "#6b847d",
  "colorIconHover": "#0a3b37",
  "colorInfo": "#0d9488",
  "colorInfoBg": "#bed4ce",
  "colorInfoBorder": "#6abaab",
  "colorInfoText": "#0d9488",
  "colorLink": "#0d9488",
  "colorLinkHover": "#ff7a59",
  "colorPrimary": "#0d9488",
  "colorPrimaryActive": "#046e68",
  "colorPrimaryBg": "#bed4ce",
  "colorPrimaryBgHover": "#91c7bb",
  "colorPrimaryBorder": "#6abaab",
  "colorPrimaryHover": "#28a193",
  "colorPrimaryText": "#0d9488",
  "colorPrimaryTextHover": "#28a193",
  "colorSplit": "#dfece7",
  "colorSuccess": "#12946b",
  "colorSuccessBg": "#c3d4cb",
  "colorSuccessBorder": "#70ba9b",
  "colorSuccessText": "#12946b",
  "colorText": "#0a3b37",
  "colorTextBase": "#000",
  "colorTextDescription": "#6b847d",
  "colorTextDisabled": "#8aa39c",
  "colorTextHeading": "#0a3b37",
  "colorTextLabel": "#557069",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "#8aa39c",
  "colorTextQuaternary": "#8aa39c",
  "colorTextSecondary": "#557069",
  "colorTextTertiary": "#6b847d",
  "colorWarning": "#c98a04",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#f0d678",
  "colorWarningText": "#c98a04",
  "colorWhite": "#fff",
  "controlHeight": 42,
  "controlHeightLG": 48,
  "controlHeightSM": 32,
  "controlItemBgActive": "#bed4ce",
  "controlItemBgHover": "#f5faf8",
  "fontFamily": "\"Inter\", \"Segoe UI Variable Text\", \"Segoe UI\", system-ui, -apple-system, Roboto, \"Helvetica Neue\", Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 15,
  "fontSizeHeading1": 34,
  "fontSizeHeading2": 28,
  "fontSizeHeading3": 22,
  "fontSizeHeading4": 18,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 18,
  "fontSizeSM": 12,
  "fontSizeXL": 22,
  "fontWeightStrong": 650,
  "lineHeight": 1.5333333333333334,
  "lineHeightLG": 1.4444444444444444,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.22s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "vital-dark": {
  "blue4": "#15417e",
  "borderRadius": 12,
  "borderRadiusLG": 18,
  "borderRadiusSM": 8,
  "borderRadiusXS": 6,
  "boxShadow": "inset 0 1px 0 rgba(255, 255, 255, 0.05)",
  "boxShadowSecondary": "0 18px 44px -16px rgba(0, 0, 0, 0.6)",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#0c2a27",
  "colorBgElevated": "#123a35",
  "colorBgLayout": "#071f1d",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255, 255, 255, 0.05)",
  "colorBorder": "rgba(255, 255, 255, 0.16)",
  "colorBorderSecondary": "rgba(255, 255, 255, 0.09)",
  "colorError": "#d66363",
  "colorErrorActive": "#a85050",
  "colorErrorBg": "#2b1a1b",
  "colorErrorBorder": "#583030",
  "colorErrorHover": "#e89390",
  "colorErrorText": "#d66363",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "#10332f",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255, 255, 255, 0.05)",
  "colorFillTertiary": "#10332f",
  "colorHighlight": "#d66363",
  "colorIcon": "rgba(230, 247, 242, 0.55)",
  "colorIconHover": "rgba(230, 247, 242, 0.94)",
  "colorInfo": "#29b7a5",
  "colorInfoBg": "#132524",
  "colorInfoBorder": "#1c4e47",
  "colorInfoText": "#29b7a5",
  "colorLink": "#53cab7",
  "colorLinkHover": "#ff8a6b",
  "colorPrimary": "#29b7a5",
  "colorPrimaryActive": "#249183",
  "colorPrimaryBg": "#1c4e47",
  "colorPrimaryBgHover": "#1f6a61",
  "colorPrimaryBorder": "#1c4e47",
  "colorPrimaryHover": "#4dccb7",
  "colorPrimaryText": "#29b7a5",
  "colorPrimaryTextHover": "#4dccb7",
  "colorSplit": "rgba(255, 255, 255, 0.09)",
  "colorSuccess": "#2fb685",
  "colorSuccessBg": "#142520",
  "colorSuccessBorder": "#1e4d3c",
  "colorSuccessText": "#2fb685",
  "colorText": "rgba(230, 247, 242, 0.94)",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(230, 247, 242, 0.55)",
  "colorTextDisabled": "rgba(230, 247, 242, 0.45)",
  "colorTextHeading": "rgba(230, 247, 242, 0.94)",
  "colorTextLabel": "rgba(230, 247, 242, 0.68)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(230, 247, 242, 0.45)",
  "colorTextQuaternary": "rgba(230, 247, 242, 0.45)",
  "colorTextSecondary": "rgba(230, 247, 242, 0.68)",
  "colorTextTertiary": "rgba(230, 247, 242, 0.55)",
  "colorWarning": "#d8a522",
  "colorWarningBg": "#2b2212",
  "colorWarningBorder": "#594719",
  "colorWarningText": "#d8a522",
  "colorWhite": "#fff",
  "controlHeight": 42,
  "controlHeightLG": 48,
  "controlHeightSM": 32,
  "controlItemBgActive": "#1c4e47",
  "controlItemBgHover": "#10332f",
  "fontFamily": "\"Inter\", \"Segoe UI Variable Text\", \"Segoe UI\", system-ui, -apple-system, Roboto, \"Helvetica Neue\", Arial, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 15,
  "fontSizeHeading1": 34,
  "fontSizeHeading2": 28,
  "fontSizeHeading3": 22,
  "fontSizeHeading4": 18,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 18,
  "fontSizeSM": 12,
  "fontSizeXL": 22,
  "fontWeightStrong": 650,
  "lineHeight": 1.5333333333333334,
  "lineHeightLG": 1.4444444444444444,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.22s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "widget": {
  "blue4": "#69b1ff",
  "borderRadius": 8,
  "borderRadiusLG": 10,
  "borderRadiusSM": 6,
  "borderRadiusXS": 2,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f5f5f5",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "#d9d9d9",
  "colorBorderSecondary": "#f0f0f0",
  "colorError": "#ff4d4f",
  "colorErrorActive": "#d9363e",
  "colorErrorBg": "#fff2f0",
  "colorErrorBorder": "#ffccc7",
  "colorErrorHover": "#ff7875",
  "colorErrorText": "#ff4d4f",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(0,0,0,0.04)",
  "colorHighlight": "#ff4d4f",
  "colorIcon": "rgba(0,0,0,0.45)",
  "colorIconHover": "rgba(0,0,0,0.88)",
  "colorInfo": "#1677ff",
  "colorInfoBg": "#e6f4ff",
  "colorInfoBorder": "#91caff",
  "colorInfoText": "#1677ff",
  "colorLink": "#1677ff",
  "colorLinkHover": "#69b1ff",
  "colorPrimary": "#111214",
  "colorPrimaryActive": "#000000",
  "colorPrimaryBg": "#4f5254",
  "colorPrimaryBgHover": "#434547",
  "colorPrimaryBorder": "#37393b",
  "colorPrimaryHover": "#1f2021",
  "colorPrimaryText": "#111214",
  "colorPrimaryTextHover": "#1f2021",
  "colorSplit": "rgba(5,5,5,0.06)",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "rgba(0,0,0,0.88)",
  "colorTextBase": "#000",
  "colorTextDescription": "rgba(0,0,0,0.45)",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "rgba(0,0,0,0.88)",
  "colorTextLabel": "rgba(0,0,0,0.65)",
  "colorTextLightSolid": "#fff",
  "colorTextPlaceholder": "rgba(0,0,0,0.25)",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "rgba(0,0,0,0.65)",
  "colorTextTertiary": "rgba(0,0,0,0.45)",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 32,
  "controlHeightLG": 40,
  "controlHeightSM": 24,
  "controlItemBgActive": "#4f5254",
  "controlItemBgHover": "rgba(0,0,0,0.04)",
  "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.2s",
  "motionDurationSlow": "0.3s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "web-light": {
  "blue4": "#69b1ff",
  "borderRadius": 10,
  "borderRadiusLG": 14,
  "borderRadiusSM": 6,
  "borderRadiusXS": 4,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f3f1ec",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "#e2ded5",
  "colorBorderSecondary": "#e2ded5",
  "colorError": "#ff3b47",
  "colorErrorActive": "#d92739",
  "colorErrorBg": "#fff1f0",
  "colorErrorBorder": "#ffb8b5",
  "colorErrorHover": "#ff6369",
  "colorErrorText": "#ff3b47",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(17, 18, 20, 0.05)",
  "colorHighlight": "#ff3b47",
  "colorIcon": "#8a877f",
  "colorIconHover": "#121212",
  "colorInfo": "#111214",
  "colorInfoBg": "#4f5254",
  "colorInfoBorder": "#37393b",
  "colorInfoText": "#111214",
  "colorLink": "#121212",
  "colorLinkHover": "#000000",
  "colorPrimary": "#ffd60a",
  "colorPrimaryActive": "#e6c000",
  "colorPrimaryBg": "rgba(255, 214, 10, 0.18)",
  "colorPrimaryBgHover": "rgba(255, 214, 10, 0.28)",
  "colorPrimaryBorder": "#cfcac0",
  "colorPrimaryHover": "#ffe14d",
  "colorPrimaryText": "#121212",
  "colorPrimaryTextHover": "#000000",
  "colorSplit": "#e2ded5",
  "colorSuccess": "#52c41a",
  "colorSuccessBg": "#f6ffed",
  "colorSuccessBorder": "#b7eb8f",
  "colorSuccessText": "#52c41a",
  "colorText": "#121212",
  "colorTextBase": "#000",
  "colorTextDescription": "#8a877f",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "#121212",
  "colorTextLabel": "#4f4d48",
  "colorTextLightSolid": "#1f1a00",
  "colorTextPlaceholder": "#8a877f",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "#4f4d48",
  "colorTextTertiary": "#8a877f",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 40,
  "controlHeightLG": 48,
  "controlHeightSM": 30,
  "controlItemBgActive": "rgba(255, 214, 10, 0.22)",
  "controlItemBgHover": "rgba(17, 18, 20, 0.05)",
  "fontFamily": "\"Outfit\", \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "web-dark": {
  "blue4": "#15417e",
  "borderRadius": 10,
  "borderRadiusLG": 14,
  "borderRadiusSM": 6,
  "borderRadiusXS": 4,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#17181b",
  "colorBgElevated": "#1d1e22",
  "colorBgLayout": "#0e0f11",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "#27292d",
  "colorBorderSecondary": "#27292d",
  "colorError": "#dc353f",
  "colorErrorActive": "#ad2d35",
  "colorErrorBg": "#2c1418",
  "colorErrorBorder": "#5b2023",
  "colorErrorHover": "#e85b61",
  "colorErrorText": "#dc353f",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255, 255, 255, 0.05)",
  "colorHighlight": "#dc353f",
  "colorIcon": "rgba(243, 241, 236, 0.42)",
  "colorIconHover": "#f3f1ec",
  "colorInfo": "#ffd60a",
  "colorInfoBg": "#2c2611",
  "colorInfoBorder": "#5b4e11",
  "colorInfoText": "#ffd60a",
  "colorLink": "#ffd60a",
  "colorLinkHover": "#ffe14d",
  "colorPrimary": "#ffd60a",
  "colorPrimaryActive": "#e6c000",
  "colorPrimaryBg": "rgba(255, 214, 10, 0.14)",
  "colorPrimaryBgHover": "rgba(255, 214, 10, 0.22)",
  "colorPrimaryBorder": "rgba(255, 214, 10, 0.42)",
  "colorPrimaryHover": "#ffe14d",
  "colorPrimaryText": "#ffd60a",
  "colorPrimaryTextHover": "#ffe14d",
  "colorSplit": "#27292d",
  "colorSuccess": "#49aa19",
  "colorSuccessBg": "#162312",
  "colorSuccessBorder": "#274916",
  "colorSuccessText": "#49aa19",
  "colorText": "#f3f1ec",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(243, 241, 236, 0.42)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "#f3f1ec",
  "colorTextLabel": "#a3a19b",
  "colorTextLightSolid": "#1f1a00",
  "colorTextPlaceholder": "rgba(243, 241, 236, 0.42)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "#a3a19b",
  "colorTextTertiary": "rgba(243, 241, 236, 0.42)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 40,
  "controlHeightLG": 48,
  "controlHeightSM": 30,
  "controlItemBgActive": "rgba(255, 214, 10, 0.2)",
  "controlItemBgHover": "rgba(255, 255, 255, 0.05)",
  "fontFamily": "\"Outfit\", \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "impuls-light": {
  "blue4": "#69b1ff",
  "borderRadius": 12,
  "borderRadiusLG": 18,
  "borderRadiusSM": 8,
  "borderRadiusXS": 4,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f7f5f2",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "#e9e4dd",
  "colorBorderSecondary": "#f1ede8",
  "colorError": "#dc2626",
  "colorErrorActive": "#b91c1c",
  "colorErrorBg": "#fef2f2",
  "colorErrorBorder": "#fecaca",
  "colorErrorHover": "#ef4444",
  "colorErrorText": "#dc2626",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(28, 25, 23, 0.05)",
  "colorHighlight": "#dc2626",
  "colorIcon": "#78716c",
  "colorIconHover": "#1c1917",
  "colorInfo": "#57534e",
  "colorInfoBg": "#f3f0ec",
  "colorInfoBorder": "#e2dcd4",
  "colorInfoText": "#44403c",
  "colorLink": "#b23a16",
  "colorLinkHover": "#8f2e11",
  "colorPrimary": "#c9431b",
  "colorPrimaryActive": "#a8360f",
  "colorPrimaryBg": "rgba(201, 67, 27, 0.08)",
  "colorPrimaryBgHover": "rgba(201, 67, 27, 0.14)",
  "colorPrimaryBorder": "#f0b9a3",
  "colorPrimaryHover": "#b23a16",
  "colorPrimaryText": "#b23a16",
  "colorPrimaryTextHover": "#8f2e11",
  "colorSplit": "#f1ede8",
  "colorSuccess": "#16a34a",
  "colorSuccessBg": "#f0fdf4",
  "colorSuccessBorder": "#bbf7d0",
  "colorSuccessText": "#15803d",
  "colorText": "#1c1917",
  "colorTextBase": "#000",
  "colorTextDescription": "#78716c",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "#1c1917",
  "colorTextLabel": "#57534e",
  "colorTextLightSolid": "#ffffff",
  "colorTextPlaceholder": "#78716c",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "#57534e",
  "colorTextTertiary": "#78716c",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 40,
  "controlHeightLG": 48,
  "controlHeightSM": 30,
  "controlItemBgActive": "rgba(201, 67, 27, 0.10)",
  "controlItemBgHover": "rgba(28, 25, 23, 0.05)",
  "fontFamily": "\"Outfit\", \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 650,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "impuls-dark": {
  "blue4": "#15417e",
  "borderRadius": 12,
  "borderRadiusLG": 18,
  "borderRadiusSM": 8,
  "borderRadiusXS": 4,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#1b1815",
  "colorBgElevated": "#26221e",
  "colorBgLayout": "#12100e",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "#3a332d",
  "colorBorderSecondary": "#2f2a25",
  "colorError": "#f87171",
  "colorErrorActive": "#dc2626",
  "colorErrorBg": "#2c1414",
  "colorErrorBorder": "#5b2020",
  "colorErrorHover": "#fca5a5",
  "colorErrorText": "#f87171",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255, 255, 255, 0.06)",
  "colorHighlight": "#f87171",
  "colorIcon": "#a39a90",
  "colorIconHover": "#f5f1ec",
  "colorInfo": "#b9b1a8",
  "colorInfoBg": "#24201c",
  "colorInfoBorder": "#3a332d",
  "colorInfoText": "#d6cfc6",
  "colorLink": "#ff9a6b",
  "colorLinkHover": "#ffb995",
  "colorPrimary": "#f26b3a",
  "colorPrimaryActive": "#d9541f",
  "colorPrimaryBg": "rgba(242, 107, 58, 0.14)",
  "colorPrimaryBgHover": "rgba(242, 107, 58, 0.22)",
  "colorPrimaryBorder": "#7a3a20",
  "colorPrimaryHover": "#ff8a5c",
  "colorPrimaryText": "#ff9a6b",
  "colorPrimaryTextHover": "#ffb995",
  "colorSplit": "#2f2a25",
  "colorSuccess": "#4ade80",
  "colorSuccessBg": "#0f2a19",
  "colorSuccessBorder": "#1f5a33",
  "colorSuccessText": "#86efac",
  "colorText": "#f5f1ec",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(245, 241, 236, 0.48)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "#f5f1ec",
  "colorTextLabel": "#b9b1a8",
  "colorTextLightSolid": "#1a1410",
  "colorTextPlaceholder": "rgba(245, 241, 236, 0.48)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "#b9b1a8",
  "colorTextTertiary": "rgba(245, 241, 236, 0.48)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 40,
  "controlHeightLG": 48,
  "controlHeightSM": 30,
  "controlItemBgActive": "rgba(242, 107, 58, 0.18)",
  "controlItemBgHover": "rgba(255, 255, 255, 0.06)",
  "fontFamily": "\"Outfit\", \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 650,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "pflaume-light": {
  "blue4": "#69b1ff",
  "borderRadius": 12,
  "borderRadiusLG": 18,
  "borderRadiusSM": 8,
  "borderRadiusXS": 4,
  "boxShadow": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(0,0,0,0.08),\n      0 3px 6px -4px rgba(0,0,0,0.12),\n      0 9px 28px 8px rgba(0,0,0,0.05)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "colorBgBase": "#fff",
  "colorBgContainer": "#ffffff",
  "colorBgElevated": "#ffffff",
  "colorBgLayout": "#f7f3f6",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "rgba(0,0,0,0.85)",
  "colorBgTextHover": "rgba(0,0,0,0.06)",
  "colorBorder": "#ecdde9",
  "colorBorderSecondary": "#f3e8f0",
  "colorError": "#c0262d",
  "colorErrorActive": "#9b1c22",
  "colorErrorBg": "#fef2f2",
  "colorErrorBorder": "#fecaca",
  "colorErrorHover": "#d9434a",
  "colorErrorText": "#c0262d",
  "colorFill": "rgba(0,0,0,0.15)",
  "colorFillAlter": "rgba(0,0,0,0.02)",
  "colorFillQuaternary": "rgba(0,0,0,0.02)",
  "colorFillSecondary": "rgba(0,0,0,0.06)",
  "colorFillTertiary": "rgba(45, 7, 41, 0.05)",
  "colorHighlight": "#c0262d",
  "colorIcon": "#8a7686",
  "colorIconHover": "#23121f",
  "colorInfo": "#6a5866",
  "colorInfoBg": "#f5e8f3",
  "colorInfoBorder": "#ead0e6",
  "colorInfoText": "#5d1157",
  "colorLink": "#7a1d75",
  "colorLinkHover": "#5d1157",
  "colorPrimary": "#7a1d75",
  "colorPrimaryActive": "#5d1157",
  "colorPrimaryBg": "rgba(122, 29, 117, 0.08)",
  "colorPrimaryBgHover": "rgba(122, 29, 117, 0.14)",
  "colorPrimaryBorder": "#ead0e6",
  "colorPrimaryHover": "#962690",
  "colorPrimaryText": "#7a1d75",
  "colorPrimaryTextHover": "#5d1157",
  "colorSplit": "#f3e8f0",
  "colorSuccess": "#16a34a",
  "colorSuccessBg": "#f0fdf4",
  "colorSuccessBorder": "#bbf7d0",
  "colorSuccessText": "#15803d",
  "colorText": "#23121f",
  "colorTextBase": "#000",
  "colorTextDescription": "#8a7686",
  "colorTextDisabled": "rgba(0,0,0,0.25)",
  "colorTextHeading": "#2d0729",
  "colorTextLabel": "#6a5866",
  "colorTextLightSolid": "#ffffff",
  "colorTextPlaceholder": "#8a7686",
  "colorTextQuaternary": "rgba(0,0,0,0.25)",
  "colorTextSecondary": "#6a5866",
  "colorTextTertiary": "#8a7686",
  "colorWarning": "#faad14",
  "colorWarningBg": "#fffbe6",
  "colorWarningBorder": "#ffe58f",
  "colorWarningText": "#faad14",
  "colorWhite": "#fff",
  "controlHeight": 40,
  "controlHeightLG": 48,
  "controlHeightSM": 30,
  "controlItemBgActive": "rgba(122, 29, 117, 0.10)",
  "controlItemBgHover": "rgba(45, 7, 41, 0.05)",
  "fontFamily": "\"Open Sans\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
 "pflaume-dark": {
  "blue4": "#15417e",
  "borderRadius": 12,
  "borderRadiusLG": 18,
  "borderRadiusSM": 8,
  "borderRadiusXS": 4,
  "boxShadow": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowSecondary": "\n      0 6px 16px 0 rgba(255,255,255,0.016),\n      0 3px 6px -4px rgba(255,255,255,0.024),\n      0 9px 28px 8px rgba(255,255,255,0.010000000000000002)\n    ",
  "boxShadowTertiary": "\n      0 1px 2px 0 rgba(255,255,255,0.010000000000000002),\n      0 1px 6px -1px rgba(255,255,255,0.006),\n      0 2px 4px 0 rgba(255,255,255,0.006)\n    ",
  "colorBgBase": "#000",
  "colorBgContainer": "#1f061c",
  "colorBgElevated": "#2c0b28",
  "colorBgLayout": "#160313",
  "colorBgMask": "rgba(0,0,0,0.45)",
  "colorBgSpotlight": "#424242",
  "colorBgTextHover": "rgba(255,255,255,0.12)",
  "colorBorder": "#4a1d44",
  "colorBorderSecondary": "#3a1535",
  "colorError": "#f87171",
  "colorErrorActive": "#dc2626",
  "colorErrorBg": "#2c1414",
  "colorErrorBorder": "#5b2020",
  "colorErrorHover": "#fca5a5",
  "colorErrorText": "#f87171",
  "colorFill": "rgba(255,255,255,0.18)",
  "colorFillAlter": "rgba(255,255,255,0.04)",
  "colorFillQuaternary": "rgba(255,255,255,0.04)",
  "colorFillSecondary": "rgba(255,255,255,0.12)",
  "colorFillTertiary": "rgba(255, 255, 255, 0.06)",
  "colorHighlight": "#f87171",
  "colorIcon": "#a8929f",
  "colorIconHover": "#f7eef5",
  "colorInfo": "#c9b5c4",
  "colorInfoBg": "#2a0d26",
  "colorInfoBorder": "#4a1d44",
  "colorInfoText": "#e6d3e1",
  "colorLink": "#e3a6dc",
  "colorLinkHover": "#f0c6ea",
  "colorPrimary": "#c063b8",
  "colorPrimaryActive": "#a24c9a",
  "colorPrimaryBg": "rgba(192, 99, 184, 0.14)",
  "colorPrimaryBgHover": "rgba(192, 99, 184, 0.22)",
  "colorPrimaryBorder": "#6e2a66",
  "colorPrimaryHover": "#d07ac8",
  "colorPrimaryText": "#e3a6dc",
  "colorPrimaryTextHover": "#f0c6ea",
  "colorSplit": "#3a1535",
  "colorSuccess": "#4ade80",
  "colorSuccessBg": "#0f2a19",
  "colorSuccessBorder": "#1f5a33",
  "colorSuccessText": "#86efac",
  "colorText": "#f7eef5",
  "colorTextBase": "#fff",
  "colorTextDescription": "rgba(247, 238, 245, 0.50)",
  "colorTextDisabled": "rgba(255,255,255,0.25)",
  "colorTextHeading": "#f7eef5",
  "colorTextLabel": "#c9b5c4",
  "colorTextLightSolid": "#1f041d",
  "colorTextPlaceholder": "rgba(247, 238, 245, 0.50)",
  "colorTextQuaternary": "rgba(255,255,255,0.25)",
  "colorTextSecondary": "#c9b5c4",
  "colorTextTertiary": "rgba(247, 238, 245, 0.50)",
  "colorWarning": "#d89614",
  "colorWarningBg": "#2b2111",
  "colorWarningBorder": "#594214",
  "colorWarningText": "#d89614",
  "colorWhite": "#fff",
  "controlHeight": 40,
  "controlHeightLG": 48,
  "controlHeightSM": 30,
  "controlItemBgActive": "rgba(192, 99, 184, 0.18)",
  "controlItemBgHover": "rgba(255, 255, 255, 0.06)",
  "fontFamily": "\"Open Sans\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif",
  "fontFamilyCode": "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  "fontSize": 14,
  "fontSizeHeading1": 38,
  "fontSizeHeading2": 30,
  "fontSizeHeading3": 24,
  "fontSizeHeading4": 20,
  "fontSizeHeading5": 16,
  "fontSizeIcon": 12,
  "fontSizeLG": 16,
  "fontSizeSM": 12,
  "fontSizeXL": 20,
  "fontWeightStrong": 600,
  "lineHeight": 1.5714285714285714,
  "lineHeightLG": 1.5,
  "lineHeightSM": 1.6666666666666667,
  "lineType": "solid",
  "lineWidth": 1,
  "lineWidthBold": 2,
  "margin": 16,
  "marginLG": 24,
  "marginMD": 20,
  "marginSM": 12,
  "marginXL": 32,
  "marginXS": 8,
  "marginXXS": 4,
  "motionDurationFast": "0.1s",
  "motionDurationMid": "0.14s",
  "motionDurationSlow": "0.2s",
  "padding": 16,
  "paddingLG": 24,
  "paddingMD": 20,
  "paddingSM": 12,
  "paddingXL": 32,
  "paddingXS": 8,
  "paddingXXS": 4,
  "zIndexBase": 0,
  "zIndexPopupBase": 1000,
  "blue": "#1677FF",
  "purple": "#722ED1",
  "cyan": "#13C2C2",
  "green": "#52C41A",
  "magenta": "#EB2F96",
  "pink": "#EB2F96",
  "red": "#F5222D",
  "orange": "#FA8C16",
  "yellow": "#FADB14",
  "volcano": "#FA541C",
  "geekblue": "#2F54EB",
  "gold": "#FAAD14",
  "lime": "#A0D911"
 },
};
/** CSS-Werte der Antd-Familien Violett, Türkis, Grün (bisher zur Laufzeit aus den Antd-Tokens abgeleitet). */
export const frozenPlainVars: Record<string, Record<string, string>> = {
 "violet-light": {
  "title-font": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "title-weight": "600",
  "title-style": "normal",
  "title-transform": "none",
  "title-tracking": "0",
  "num-weight": "600",
  "num-style": "normal",
  "orn-w": "0px",
  "orn-h": "0px",
  "orn-skew": "0deg",
  "radius": "8px",
  "radius-lg": "10px",
  "display": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "control-h": "32px",
  "mark": "#722ed1",
  "mark-ink": "#fff",
  "mark-soft": "#f9f0ff",
  "mark-text": "#1677ff",
  "signal": "#ff4d4f",
  "signal-strong": "#d9363e",
  "bg": "#f5f5f5",
  "surface": "#ffffff",
  "surface-2": "rgba(0,0,0,0.02)",
  "elevated": "#ffffff",
  "text": "rgba(0,0,0,0.88)",
  "text-2": "rgba(0,0,0,0.65)",
  "text-3": "rgba(0,0,0,0.45)",
  "line": "#f0f0f0",
  "fill": "rgba(0,0,0,0.04)",
  "primary": "#722ed1",
  "on-primary": "#fff",
  "primary-text": "#1677ff",
  "card-shadow": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "rail": "#ffffff",
  "rail-glow": "none",
  "rail-line": "rgba(5,5,5,0.06)",
  "rail-text": "rgba(0,0,0,0.65)",
  "rail-strong": "rgba(0,0,0,0.88)",
  "rail-muted": "rgba(0,0,0,0.45)",
  "rail-hover": "rgba(0,0,0,0.04)",
  "rail-active": "#f9f0ff",
  "rail-active-text": "#722ed1",
  "rail-field": "rgba(0,0,0,0.04)",
  "page-glow": "none",
  "head-glow": "rgba(0,0,0,0.88)",
  "head-text": "#ffffff",
  "select": "#722ed1",
  "on-select": "#fff",
  "select-soft": "#f9f0ff"
 },
 "violet-dark": {
  "title-font": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "title-weight": "600",
  "title-style": "normal",
  "title-transform": "none",
  "title-tracking": "0",
  "num-weight": "600",
  "num-style": "normal",
  "orn-w": "0px",
  "orn-h": "0px",
  "orn-skew": "0deg",
  "radius": "8px",
  "radius-lg": "10px",
  "display": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "control-h": "32px",
  "mark": "#642ab5",
  "mark-ink": "#fff",
  "mark-soft": "#301c4d",
  "mark-text": "#1668dc",
  "signal": "#dc4446",
  "signal-strong": "#ad393a",
  "bg": "#000000",
  "surface": "#141414",
  "surface-2": "rgba(255,255,255,0.04)",
  "elevated": "#1f1f1f",
  "text": "rgba(255,255,255,0.85)",
  "text-2": "rgba(255,255,255,0.65)",
  "text-3": "rgba(255,255,255,0.45)",
  "line": "#303030",
  "fill": "rgba(255,255,255,0.08)",
  "primary": "#642ab5",
  "on-primary": "#fff",
  "primary-text": "#1668dc",
  "card-shadow": "none",
  "rail": "#141414",
  "rail-glow": "none",
  "rail-line": "rgba(253,253,253,0.12)",
  "rail-text": "rgba(255,255,255,0.65)",
  "rail-strong": "rgba(255,255,255,0.85)",
  "rail-muted": "rgba(255,255,255,0.45)",
  "rail-hover": "rgba(255,255,255,0.08)",
  "rail-active": "#301c4d",
  "rail-active-text": "#642ab5",
  "rail-field": "rgba(255,255,255,0.08)",
  "page-glow": "none",
  "head-glow": "#1f1f1f",
  "head-text": "rgba(255,255,255,0.85)",
  "select": "#642ab5",
  "on-select": "#fff",
  "select-soft": "#301c4d"
 },
 "teal-light": {
  "title-font": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "title-weight": "600",
  "title-style": "normal",
  "title-transform": "none",
  "title-tracking": "0",
  "num-weight": "600",
  "num-style": "normal",
  "orn-w": "0px",
  "orn-h": "0px",
  "orn-skew": "0deg",
  "radius": "8px",
  "radius-lg": "10px",
  "display": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "control-h": "32px",
  "mark": "#13c2c2",
  "mark-ink": "#fff",
  "mark-soft": "#e6fffb",
  "mark-text": "#1677ff",
  "signal": "#ff4d4f",
  "signal-strong": "#d9363e",
  "bg": "#f5f5f5",
  "surface": "#ffffff",
  "surface-2": "rgba(0,0,0,0.02)",
  "elevated": "#ffffff",
  "text": "rgba(0,0,0,0.88)",
  "text-2": "rgba(0,0,0,0.65)",
  "text-3": "rgba(0,0,0,0.45)",
  "line": "#f0f0f0",
  "fill": "rgba(0,0,0,0.04)",
  "primary": "#13c2c2",
  "on-primary": "#fff",
  "primary-text": "#1677ff",
  "card-shadow": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "rail": "#ffffff",
  "rail-glow": "none",
  "rail-line": "rgba(5,5,5,0.06)",
  "rail-text": "rgba(0,0,0,0.65)",
  "rail-strong": "rgba(0,0,0,0.88)",
  "rail-muted": "rgba(0,0,0,0.45)",
  "rail-hover": "rgba(0,0,0,0.04)",
  "rail-active": "#e6fffb",
  "rail-active-text": "#13c2c2",
  "rail-field": "rgba(0,0,0,0.04)",
  "page-glow": "none",
  "head-glow": "rgba(0,0,0,0.88)",
  "head-text": "#ffffff",
  "select": "#13c2c2",
  "on-select": "#fff",
  "select-soft": "#e6fffb"
 },
 "teal-dark": {
  "title-font": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "title-weight": "600",
  "title-style": "normal",
  "title-transform": "none",
  "title-tracking": "0",
  "num-weight": "600",
  "num-style": "normal",
  "orn-w": "0px",
  "orn-h": "0px",
  "orn-skew": "0deg",
  "radius": "8px",
  "radius-lg": "10px",
  "display": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "control-h": "32px",
  "mark": "#13a8a8",
  "mark-ink": "#fff",
  "mark-soft": "#144848",
  "mark-text": "#1668dc",
  "signal": "#dc4446",
  "signal-strong": "#ad393a",
  "bg": "#000000",
  "surface": "#141414",
  "surface-2": "rgba(255,255,255,0.04)",
  "elevated": "#1f1f1f",
  "text": "rgba(255,255,255,0.85)",
  "text-2": "rgba(255,255,255,0.65)",
  "text-3": "rgba(255,255,255,0.45)",
  "line": "#303030",
  "fill": "rgba(255,255,255,0.08)",
  "primary": "#13a8a8",
  "on-primary": "#fff",
  "primary-text": "#1668dc",
  "card-shadow": "none",
  "rail": "#141414",
  "rail-glow": "none",
  "rail-line": "rgba(253,253,253,0.12)",
  "rail-text": "rgba(255,255,255,0.65)",
  "rail-strong": "rgba(255,255,255,0.85)",
  "rail-muted": "rgba(255,255,255,0.45)",
  "rail-hover": "rgba(255,255,255,0.08)",
  "rail-active": "#144848",
  "rail-active-text": "#13a8a8",
  "rail-field": "rgba(255,255,255,0.08)",
  "page-glow": "none",
  "head-glow": "#1f1f1f",
  "head-text": "rgba(255,255,255,0.85)",
  "select": "#13a8a8",
  "on-select": "#fff",
  "select-soft": "#144848"
 },
 "green-light": {
  "title-font": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "title-weight": "600",
  "title-style": "normal",
  "title-transform": "none",
  "title-tracking": "0",
  "num-weight": "600",
  "num-style": "normal",
  "orn-w": "0px",
  "orn-h": "0px",
  "orn-skew": "0deg",
  "radius": "8px",
  "radius-lg": "10px",
  "display": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "control-h": "32px",
  "mark": "#52c41a",
  "mark-ink": "#fff",
  "mark-soft": "#f6ffed",
  "mark-text": "#1677ff",
  "signal": "#ff4d4f",
  "signal-strong": "#d9363e",
  "bg": "#f5f5f5",
  "surface": "#ffffff",
  "surface-2": "rgba(0,0,0,0.02)",
  "elevated": "#ffffff",
  "text": "rgba(0,0,0,0.88)",
  "text-2": "rgba(0,0,0,0.65)",
  "text-3": "rgba(0,0,0,0.45)",
  "line": "#f0f0f0",
  "fill": "rgba(0,0,0,0.04)",
  "primary": "#52c41a",
  "on-primary": "#fff",
  "primary-text": "#1677ff",
  "card-shadow": "\n      0 1px 2px 0 rgba(0,0,0,0.05),\n      0 1px 6px -1px rgba(0,0,0,0.03),\n      0 2px 4px 0 rgba(0,0,0,0.03)\n    ",
  "rail": "#ffffff",
  "rail-glow": "none",
  "rail-line": "rgba(5,5,5,0.06)",
  "rail-text": "rgba(0,0,0,0.65)",
  "rail-strong": "rgba(0,0,0,0.88)",
  "rail-muted": "rgba(0,0,0,0.45)",
  "rail-hover": "rgba(0,0,0,0.04)",
  "rail-active": "#f6ffed",
  "rail-active-text": "#52c41a",
  "rail-field": "rgba(0,0,0,0.04)",
  "page-glow": "none",
  "head-glow": "rgba(0,0,0,0.88)",
  "head-text": "#ffffff",
  "select": "#52c41a",
  "on-select": "#fff",
  "select-soft": "#f6ffed"
 },
 "green-dark": {
  "title-font": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "title-weight": "600",
  "title-style": "normal",
  "title-transform": "none",
  "title-tracking": "0",
  "num-weight": "600",
  "num-style": "normal",
  "orn-w": "0px",
  "orn-h": "0px",
  "orn-skew": "0deg",
  "radius": "8px",
  "radius-lg": "10px",
  "display": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n'Noto Color Emoji'",
  "control-h": "32px",
  "mark": "#49aa19",
  "mark-ink": "#fff",
  "mark-soft": "#274916",
  "mark-text": "#1668dc",
  "signal": "#dc4446",
  "signal-strong": "#ad393a",
  "bg": "#000000",
  "surface": "#141414",
  "surface-2": "rgba(255,255,255,0.04)",
  "elevated": "#1f1f1f",
  "text": "rgba(255,255,255,0.85)",
  "text-2": "rgba(255,255,255,0.65)",
  "text-3": "rgba(255,255,255,0.45)",
  "line": "#303030",
  "fill": "rgba(255,255,255,0.08)",
  "primary": "#49aa19",
  "on-primary": "#fff",
  "primary-text": "#1668dc",
  "card-shadow": "none",
  "rail": "#141414",
  "rail-glow": "none",
  "rail-line": "rgba(253,253,253,0.12)",
  "rail-text": "rgba(255,255,255,0.65)",
  "rail-strong": "rgba(255,255,255,0.85)",
  "rail-muted": "rgba(255,255,255,0.45)",
  "rail-hover": "rgba(255,255,255,0.08)",
  "rail-active": "#274916",
  "rail-active-text": "#49aa19",
  "rail-field": "rgba(255,255,255,0.08)",
  "page-glow": "none",
  "head-glow": "#1f1f1f",
  "head-text": "rgba(255,255,255,0.85)",
  "select": "#49aa19",
  "on-select": "#fff",
  "select-soft": "#274916"
 }
};
